import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { HttpErrorsService } from './http-errors.service';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { Users } from '../models/users';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  token: any;
  usernameId: any;
  username: any;
  role: any;
  menu: any[] = [];
  homePage: any;
  httpOptions: any = {}
  img: any;
  options: any = {}

  constructor( private http: HttpClient,
               private _httpErrors: HttpErrorsService) { 

                this.httpOptions = new HttpHeaders({
                  'Content-Type': 'aplication/json',
                }),
                {observe: 'response'}

                const headers = new HttpHeaders({
                  'Content-Type': 'aplication/json',
                })

                this.options = {
                  headers: headers,
                  observe: "response"
              };
          
              // Carga Storage
              this.getStorage();
}

  // Inicio de Sesión 
login(authData: Users){

    return new Promise ((resolve =>{
    console.log('Encabezdo a enviar ', JSON.stringify(this.options));
    
    this.http.post(`${environment.urlAPIS}/api/v1/auth`, authData, this.httpOptions)
    .subscribe(data =>{
      let auth = JSON.parse(JSON.stringify(data));
      console.log('Auth ', auth);
      if (auth){
        this.setStorage(auth);
        resolve(auth);
      // } else { //HTTP Errors
      //  console.log('Hubo un error Http', auth);
      //  this._httpErrors.getError(auth.status, auth);
      //  resolve(null);
       }
    },err =>{
      let error = {
        error: {
          error: {
            message: err.error.message
          }
        }
      }
      console.error('ERROR!!!! ', error);
      if (error.error != null){
        this._httpErrors.getError(err.status, error);
      } else {
        this._httpErrors.getError(err.status, 'Error en la conexión al servidor');
      }
      resolve(null);
    });
  
  }))
  }


  setStorage(auth){
    localStorage.setItem('token', auth.access_token);
    // Solo colca un nombre y un apellido
    //let firstName = '';
    //let index = 0;
    // if ( auth.user.name.indexOf(' ') != -1){
    //   index = auth.user.name.indexOf(' ');
    //   firstName = auth.user.name.substring(0, index);
    // } else {
    //   firstName = auth.user.name
    // }
  
    // let lastName = '';
    // let indexL = 0;
    // if ( auth.user.lastName.indexOf(' ') != -1){
    //   indexL = auth.user.lastName.indexOf(' ');
    //   lastName = auth.user.lastName.substring(0, indexL);
    // } else {
    //   lastName = auth.user.lastName
    // }

    localStorage.setItem('username', auth.user.name);
    localStorage.setItem('usernameId', auth.user._id);
    localStorage.setItem('menu', JSON.stringify(auth.menu));
    localStorage.setItem('homePage', auth.homePage);
    localStorage.setItem('role', auth.user.role);
    
    this.token = auth.access_token;
    this.username = auth.user.name+' '+auth.user.lastName;
    this.usernameId = auth.user._id;
    this.role = auth.user.role;
    this.menu = auth.menu;
    this.homePage = auth.homePage;
  }

  // Cerrar Sesión
logout(){
  return new Promise ((resolve =>{
    console.log('LogOut de AuthService');
    this.username = null;
    this.usernameId = null;
    this.role = null;
    this.token = null;
    this.menu = [];
    this.homePage = null;
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('usernameId');
    localStorage.removeItem('menu');
    localStorage.removeItem('homePage');
    localStorage.removeItem('role');
    resolve();
  }))
}

getStorage(){
  if ( localStorage.getItem('token')){
    this.token = localStorage.getItem('token');
    this.username = localStorage.getItem('username');
    this.usernameId = localStorage.getItem('usernameId');
    this.menu = JSON.parse(localStorage.getItem('menu'));
    this.homePage = localStorage.getItem('homePage');
    this.role = localStorage.getItem('role');
  } else {
    this.token = undefined;
    this.username = undefined;
    this.usernameId = undefined;
    this.menu = undefined;
    this.homePage = undefined;
    this.role = undefined;
  }
}

//Se encuentra Logeado
isAuth(){
  this.getStorage();
    return (this.token)? true: false    
}

isAdmin(){
  return (this.role == "ADMIN") ? true : false
}

}
